import store from '../../store'
export default {
  inserted: function (el, binding) {
    // 拿到el-button这个按钮标签
    // 拿到v-permission自定义指令中{action:'add'}
    const action = binding.value.action // action就拿到v-permission中的action对应的值.
    // 判断,当前的路由所对应的组件中,如何判断用户是否具备action的权限,currentRoute拿到当前组件的路由规则
    const permission = store.getters.permissions
    if (permission && !permission.some((item) => item.name === action)) {
      const disabled = binding.value.disabled
      // 删除el元素
      if (disabled) {
        el.disabled = true
        el.classList.add('is-disabled')
      } else {
        el.parentNode.removeChild(el)
      }
      // 禁用元素
      // el.disabled = true
      // el.classList.add('is-disabled')
    }
  }
}
